import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e47e0fd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "flex-pool-search" }, null, -1))
const _hoisted_4 = { class: "user" }
const _hoisted_5 = { class: "nav-menu" }
const _hoisted_6 = { class: "choose-client" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "option-row--align" }
const _hoisted_9 = { class: "option-text" }
const _hoisted_10 = ["value", "checked"]
const _hoisted_11 = {
  key: 1,
  class: "option-text option-text--no-record"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_FaIcon = _resolveComponent("FaIcon")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_FormRow = _resolveComponent("FormRow")!
  const _component_OverlayDialog = _resolveComponent("OverlayDialog")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Breadcrumbs),
      _hoisted_3,
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "header__right",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.triggerNavigationMenu && _ctx.triggerNavigationMenu(...args)))
      }, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.compClientInitials), 1),
        _createElementVNode("p", {
          class: _normalizeClass(["user__name", { 'user__name--many-clients': _ctx.numOfCompanyClients > 1 }])
        }, _toDisplayString(_ctx.companyName), 3),
        _createElementVNode("button", null, [
          _withDirectives(_createVNode(_component_FaIcon, {
            class: _normalizeClass(['icon__angle-down', { 'icon__angle-down--open': _ctx.isNavMenuOpen }]),
            icon: ['far', 'angle-down']
          }, null, 8, ["class"]), [
            [_vShow, _ctx.numOfCompanyClients > 1]
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              class: "nav-menu-item",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModalChooseClient && _ctx.openModalChooseClient(...args)))
            }, [
              _createVNode(_component_FaIcon, {
                class: "icon__arrow-repeat",
                icon: ['far', 'arrows-repeat']
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("choose_your_client")), 1)
            ])
          ])
        ], 512), [
          [_vShow, _ctx.isNavMenuOpen]
        ])
      ])), [
        [_directive_click_away, _ctx.closeNavigationMenu]
      ])
    ]),
    _createVNode(_component_OverlayDialog, {
      "modal-id": _ctx.modalIdChooseClient,
      "is-open": _ctx.isChooseClientModalOpen,
      "dark-overlay": false,
      "disable-close": false,
      "hide-close": false,
      onClose: _ctx.closeModalChooseClient
    }, {
      header: _withCtx(() => [
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t("choose_your_client")), 1)
      ]),
      content: _withCtx(() => [
        _createVNode(_component_Search, {
          modelValue: _ctx.searchValue,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchValue) = $event)),
            _ctx.updateSearch
          ],
          modelModifiers: { trim: true },
          onClear: _ctx.clearSearch,
          placeholder: _ctx.$t('menu.find_a_company'),
          "icon-right": "",
          class: "search-input"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onClear", "placeholder"]),
        _createVNode(_component_FormRow, null, {
          default: _withCtx(() => [
            _createElementVNode("ul", {
              class: "option-holder",
              onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.debouncedFn && _ctx.debouncedFn(...args)))
            }, [
              (_ctx.companyClientsList.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.companyClientsList, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.companyClientId,
                      onClick: ($event: any) => (_ctx.selectClient(item)),
                      class: "option-row"
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_Avatar, {
                          name: item.tradeName,
                          "last-name": _ctx.companyLastName(item.tradeName),
                          "img-path": item.profilePictureUrl,
                          class: "option-avatar",
                          "custom-size": 40
                        }, null, 8, ["name", "last-name", "img-path"]),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(item.tradeName), 1)
                      ]),
                      _createElementVNode("input", {
                        name: "itemOptions",
                        type: "radio",
                        value: item.companyClientId,
                        checked: _ctx.companyId === item.companyClientId
                      }, null, 8, _hoisted_10)
                    ], 8, _hoisted_7))
                  }), 128))
                : (_openBlock(), _createElementBlock("h2", _hoisted_11, _toDisplayString(_ctx.$t('global.no_record_found')), 1))
            ], 32)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modal-id", "is-open", "onClose"])
  ]))
}